<div class="flex flex-column flex-wrap gap-2 justify-content-center">
    <h1 class="m-1 text-center">Blog</h1>
    <div class="flex w-11 m-auto my-2 justify-content-center">
        <p-selectButton id="cities" [options]="articleTypeList" optionLabel="description" optionValue="id" [(ngModel)]="selectedArticleType"
                [multiple]="false" (onOptionClick)="filterByArticleType($event)"></p-selectButton>
    </div>
</div>
<div class="flex flex-row flex-wrap gap-2 justify-content-center my-3" >
    <div *ngFor="let article of articleList; let i = index" class="w-10 sm:w-4" style="cursor: pointer; min-height: 307px;">
        <a [routerLink]="getUrlArticle(article.urlId)" title="{{ article.metaTitle }}" ariaLabel="{{ article.metaTitle }}" class="no-underline">
            <div class="shadow-2 hover:shadow-8">
                <img src="{{ thumbnailLocation + article.image }}" (onImageError)="handleError($event)"
                    alt="{{ article.title }}" class="w-full max-h-20rem" />
                <div class="p-3">
                    <h2 class="text-color m-0">{{ article.title }}</h2>
                    <p class="text-color">{{ article.summary }}</p>
                </div>
            </div>
        </a>  
</div>